import Vue from "vue";
import "./plugins/fontawesome";
import App from "./app.vue";
import router from "./router";
import store from "./store";
import InputField from "@/components/form/input-field";
import InputText from "@/components/form/input-text";
import InputSwitch from "@/components/form/input-switch";
import InputSelect from "@/components/form/input-select";
import InputFile from "@/components/form/input-file";
import Paginate from "@/components/paginate";
import DateFilter from "@/filters/date";
import DateTimeFilter from "@/filters/datetime"
import TimeFilter from "@/filters/time"

Vue.config.productionTip = false;

Vue.component("input-field", InputField);
Vue.component("input-text", InputText);
Vue.component("input-switch", InputSwitch);
Vue.component("input-select", InputSelect);
Vue.component("input-file", InputFile);
Vue.component("app-paginate", Paginate);

Vue.filter("date", DateFilter);
Vue.filter("datetime", DateTimeFilter);
Vue.filter("time", TimeFilter);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
